import React, { useEffect, useState } from 'react';
import { Form, Button, Typography, Checkbox, message, Input } from 'antd';
import { useDriverContext } from '../../context/DriverContext';

const { Title, Paragraph } = Typography;

const Step20 = ({ form, prev, next, resetForm }) => {
  const [consent, setConsent] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({});

  const { driverName } = useDriverContext();
  console.log('driverName: ', driverName);


  // const handleCheckboxChange = async (e) => {
  //   const value = await form.validateFields()

  //   form.setFieldsValue({
  //     understandAssistanceAnimal:  e.target.checked  ? "agree" : undefined,
  //   })
    
      
  // };




  const checkVal = async () => {

    const values = await form.validateFields();

    return values
  }


  const handleSubmit = () => {
    if (consent) {
      // Retrieve all form values
      const allValues = form.getFieldsValue();
      console.log('All Form Values11:', allValues);
      setFormData(allValues)
      // Submit the form
      next()
      message.success('Thank you for your submission. Your ID Application has been sent.');
      setSubmitted(true);
    } else {
      message.error('You must give consent to proceed.');
    }
  };



  if (submitted) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Title level={2}>Thank You!</Title>
        <Paragraph>Your ID Application has been sent.</Paragraph>
        <Paragraph>Here is a downloadable link of your application if you would like a copy.</Paragraph>
        <Button type="primary" href="/path/to/your/application.pdf" download="ID_Application.pdf">
          Download Submission PDF
        </Button>
        <div style={{ marginTop: '16px' }}>
          <Button type="default" onClick={resetForm}>
            Start Over
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Form layout="vertical" form={form}>
      <Title level={2}>Driver Consent</Title>

      <Paragraph>
        Before we can access and upload your driving record to the Point to Point
        Transport Commission's Driver Vehicle Dashboard (DVD), you will need to
        provide consent confirming that you are eligible to be a driver under the
        point to point transport law.
      </Paragraph>

      <Title level={4}>Details:</Title>

      {/* <Paragraph>Full Name: {formData.firstName}</Paragraph>
      <Paragraph>D/L Number: {formData.dlNumber}</Paragraph>
      <Paragraph>D.O.B: {formData.dob}</Paragraph> */}

      <Paragraph>
        Authorised Service Provider: Opera Taxis Pty Ltd
      </Paragraph>

      <Title level={4}>Consent</Title>

      <Paragraph>
        I <strong>{driverName?.firstName} {driverName?.lastName}</strong> consent to Opera Taxis Taxi Network entering my driver license into the
        DVD for the purpose of confirming that I am an eligible driver under point
        to point transport law. I understand that Opera Taxis Taxi Network will be
        able to check whether I have the relevant driver licence to provide
        passenger services and whether I have any disqualifying offences
        recorded against my name (criminal charges, serious driving offences and
        point to point safety offences).
      </Paragraph>

      <Form.Item name="consent" >
        <Checkbox checked={consent} onChange={(e)=>{
 form.setFieldsValue({
  consent: e.target.checked ? "agree" : undefined})
  setConsent(e.target.checked);
        }}>
          I give consent to Opera Taxis Taxi Network. *
        </Checkbox>
      </Form.Item>

      <Form.Item>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step20;
